var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2901_24358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 200,
    height: 200,
    rx: 20,
    fill: "url(#pattern0)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2901_24358",
    x: 0,
    y: 0,
    width: 208,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2901_24358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2901_24358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2901_24358",
    transform: "scale(0.00444444)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2901_24358",
    width: 225,
    height: 225,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBig);
export default __webpack_public_path__ + "static/media/Linkedin-big.0d89560170806c4eb489c99ee44af48d.svg";
export { ForwardRef as ReactComponent };